const minHeight = theme => ({
  ...theme("spacing"),
})

module.exports = {
  minHeight,
}

exports.default = minHeight
